import { put, call, all, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import get from 'lodash/get';
import {
  fetchAdminEquipSnoSuccess,
  fetchAdminEquipSnoFailure,
  addAdminEquipSnoSuccess,
  addAdminEquipSnoFailure,
  updateSerialNoSuccess,
  updateSerialNoFailure,
  deleteSerialNoSuccess,
  deleteSerialNoFailure,
  fetchAdminEquipTypeSnoSuccess,
  fetchAdminEquipTypeSnoFailure,
  fetchAdminEquipSubTypeSnoSuccess,
  fetchAdminEquipSubTypeSnoFailure,
  fetchAdminEquipDocTypeSuccess,
  fetchAdminEquipDocTypeFailure,
  fetchAdminEquipDocListSuccess,
  fetchAdminEquipDocListFailure,
  addDocumentTypeSuccess,
  addDocumentTypeFailure,
  fetchAdminEquipCategorySuccess,
  fetchAdminEquipCategoryFailure,
  fetchAdminDocumentSubTypeSnoSuccess,
  fetchAdminDocumentSubTypeSnoFailure,
  deleteDocumentListReportSuccess,
  deleteDocumentListReportFailure,
  updateDocumentSuccess,
  updateDocumentFailure,
} from './action';
import {
  ADD_EQUIPMENT_SNO,
  DELETE_EQUIPMENT_SNO,
  FETCH_ADMIN_EQUIPMENT_SNO,
  FETCH_ADMIN_EQUIPMENT_TYPE_SNO,
  FETCH_ADMIN_EQUIPMENT_SUB_TYPE_SNO,
  UPDATE_EQUIPMENT_SNO,
  FETCH_ADMIN_EQUIPMENT_DOC_TYPE,
  FETCH_ADMIN_EQUIPMENT_DOC_LIST,
  ADD_DOCUMENT_TYPE,
  FETCH_ADMIN_EQUIPMENT_CATEGORY,
  DELETE_DOCUMENT_LIST_REPORT,
  FETCH_ADMIN_DOCUMENT_SUB_TYPE_SNO,
  UPDATE_DOCUMENT,
} from './types';
import adminAxiosConfig from '../../../services/adminAxiosConfig';
import { fetchAdminPihEquipTypes } from '../equipmentTypes/action';
import axios from 'axios';

/** Maximum number of files allowed per document upload (validation in saga as safety) */
const MAX_DOCUMENT_FILES = 15;

/**
 * @typedef {Object} MultipleFileUploadRequest
 * @property {string} equipmentTypeId
 * @property {string} documentTypeId
 * @property {File[]} [certificate] - selected files (1 to MAX_DOCUMENT_FILES)
 * @property {string} [expirationDate]
 * @property {string} [reminderList]
 */

/** Get all listed equipment types*/
function* fetchAdminEquipSno(payload) {
  try {
    var res;
    if (payload.pihEquipmentTypeCategory && payload.pihEquipmentType) {
      res = yield adminAxiosConfig.get(
        `/equipments?pihEquipmentTypeCategory=${encodeURIComponent(
          payload.pihEquipmentTypeCategory
        )}&pihEquipmentType=${encodeURIComponent(payload.pihEquipmentType)}`
      );
    } else if (payload.pihEquipmentType) {
      res = yield adminAxiosConfig.get(
        `/equipments-for-pih-equipment-type?pihEquipmentType=${encodeURIComponent(
          payload.pihEquipmentType
        )}`
      );
    } else {
      res = yield adminAxiosConfig.get(`/equipments?equipmentTypeId=${payload.id}`);
    }

    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchAdminEquipSnoSuccess({ response }));
    } else {
      yield put(fetchAdminEquipSnoFailure());
      notification.warn({
        message: 'Something went wrong. Please Reload and try again',
      });
    }
  } catch (error) {
    yield put(fetchAdminEquipSnoFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the Equipments.',
      description: `${error.error}`,
    });
  }
}

/** Get all listed equipment category*/
function* fetchAdminEquipCategory(payload) {
  try {
    var res;
    if (payload.pihEquipmentTypeCategory && payload.pihEquipmentType) {
      res = yield adminAxiosConfig.get(`/equipment-categories/v2`);
      // res = yield adminAxiosConfig.get(`/equipments?pihEquipmentTypeCategory=${encodeURIComponent(payload.pihEquipmentTypeCategory)}&pihEquipmentType=${encodeURIComponent(payload.pihEquipmentType)}`);
    } else {
      res = yield adminAxiosConfig.get(`/equipment-categories/v2`);
    }

    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchAdminEquipCategorySuccess({ response }));
    } else {
      yield put(fetchAdminEquipCategoryFailure());
      notification.warn({
        message: 'Something went wrong. Please Reload and try again',
      });
    }
  } catch (error) {
    yield put(fetchAdminEquipCategoryFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the Equipments.',
      description: `${error.error}`,
    });
  }
}

/** Get all listed equipment types for admin page (NEWLY ADDED API)*/
function* fetchAdminEquipTypeSno(payload) {
  try {
    var res;
    if (payload.searchKey && payload.pihEquipmentType) {
      res = yield adminAxiosConfig.get(
        `/equipments-for-pih-equipment-type?searchKey=${encodeURIComponent(
          payload.searchKey
        )}&pihEquipmentType=${encodeURIComponent(payload.pihEquipmentType)}`
      );
    } else {
      res = yield adminAxiosConfig.get(
        `/equipments-for-pih-equipment-type?pihEquipmentType=${encodeURIComponent(
          payload.pihEquipmentType
        )}`
      );
    }

    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchAdminEquipTypeSnoSuccess({ response }));
    } else {
      yield put(fetchAdminEquipTypeSnoFailure());
      notification.warn({
        message: 'Something went wrong. Please Reload and try again',
      });
    }
  } catch (error) {
    yield put(fetchAdminEquipTypeSnoFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the Equipments.',
      description: `${error.error}`,
    });
  }
}

/** Get all listed equipment sub types for admin page (NEWLY ADDED API)*/
function* fetchAdminEquipSubTypeSno(payload) {
  try {
    var res;
    if (payload.searchKey && payload.pihEquipmentType) {
      res = yield adminAxiosConfig.get(
        `/equipment-sub-category/v2?searchKey=${encodeURIComponent(
          payload.searchKey
        )}&pihEquipmentTypeCategory=${encodeURIComponent(payload.pihEquipmentTypeCategory)}`
      );
    } else {
      res = yield adminAxiosConfig.get(
        `/equipment-sub-category/v2?pihEquipmentTypeCategory=${encodeURIComponent(
          payload.pihEquipmentTypeCategory
        )}`
      );
    }
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchAdminEquipSubTypeSnoSuccess({ response }));
    } else {
      yield put(fetchAdminEquipSubTypeSnoFailure());
      notification.warn({
        message: 'Something went wrong. Please Reload and try again',
      });
    }
  } catch (error) {
    yield put(fetchAdminEquipSubTypeSnoFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while fetching the Equipments Sub Category.',
      description: `${error.error}`,
    });
  }
}

/** Get all listed document sub category drop down*/
function* fetchAdminDocumentSubTypeSno(payload) {
  try {
    var res;
    if (payload.searchKey && payload.pihEquipmentType) {
      res = yield adminAxiosConfig.get(
        `/equipment-sub-category/v2?searchKey=${encodeURIComponent(
          payload.searchKey
        )}&pihEquipmentTypeCategory=${encodeURIComponent(payload.pihEquipmentTypeCategory)}`
      );
    } else {
      res = yield adminAxiosConfig.get(
        `/equipment-sub-category/v2?pihEquipmentTypeCategory=${encodeURIComponent(
          payload.pihEquipmentTypeCategory
        )}`
      );
    }
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchAdminDocumentSubTypeSnoSuccess({ response }));
    } else {
      yield put(fetchAdminDocumentSubTypeSnoFailure());
      notification.warn({
        message: 'Something went wrong. Please Reload and try again',
      });
    }
  } catch (error) {
    yield put(fetchAdminDocumentSubTypeSnoFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while fetching the Equipments Sub Category.',
      description: `${error.error}`,
    });
  }
}

/** Get all listed equipment document types for admin page (NEWLY ADDED API)*/
function* fetchAdminEquipDocType() {
  try {
    const res = yield adminAxiosConfig.get(`/equipment/documents-types`);
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchAdminEquipDocTypeSuccess({ response }));
    } else {
      yield put(fetchAdminEquipDocTypeFailure());
      notification.warn({
        message: 'Something went wrong. Please Reload and try again',
      });
    }
  } catch (error) {
    yield put(fetchAdminEquipDocTypeFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while fetching the document types.',
      description: `${error.error}`,
    });
  }
}

/** Get all listed equipment documents list for admin page (NEWLY ADDED API)*/
function* fetchAdminEquipDocList({ equipmentTypeId, equipmentId, documentTypeId }) {
  try {
    const res = yield adminAxiosConfig.get(
      `/equipment/documents/all?equipmentTypeId=${equipmentTypeId}&equipmentId=${equipmentId}&documentTypeId=${documentTypeId}&pageNumber=1`
    );
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchAdminEquipDocListSuccess({ response }));
    } else {
      yield put(fetchAdminEquipDocListFailure());
      notification.warn({
        message: 'Something went wrong. Please Reload and try again',
      });
    }
  } catch (error) {
    yield put(fetchAdminEquipDocListFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while fetching the documents list.',
      description: `${error.error}`,
    });
  }
}

/**
 * Build payload for POST /equipment/documents (single document).
 * Used for update flow; batch add uses buildDocumentBatchPayload.
 */
function buildDocumentPostPayload(payload, documentName, fileKey) {
  const body = {
    equipmentTypeId: payload.equipmentTypeId,
    equipmentIds: payload.equipmentIds,
    documentTypeId: payload.documentTypeId,
    documentName,
    fileKey,
    expirationDate: payload.expirationDate,
    reminderList: payload.reminderList,
  };
  return body;
}

/**
 * Build payload for single POST /equipment/documents with documents array.
 * documents: [{ documentName, fileKey }, ...]
 */
function buildDocumentBatchPayload(payload, certificate, presignedFiles) {
  const documents = certificate.map((file, i) => {
    const item = presignedFiles[i] || {};
    const fileKey = item.fileKey || item.file_key;
    return { documentName: file.name, fileKey };
  });
  return {
    equipmentTypeId: payload.equipmentTypeId,
    equipmentIds: payload.equipmentIds,
    documentTypeId: payload.documentTypeId,
    documents,
    expirationDate: payload.expirationDate,
    reminderList: payload.reminderList,
  };
}

/**
 * Build request body for single presigned-url API call (multiple files).
 * files: [{ fileName, contentType }, ...]
 */
function buildPresignedUrlRequestPayload(payload, certificate) {
  return {
    equipmentTypeId: payload.equipmentTypeId,
    documentTypeId: payload.documentTypeId,
    files: certificate.map((file) => ({
      fileName: file.name,
      contentType: file.type,
    })),
  };
}

/** Normalize presigned response: support data.files or data.data.files, ensure array */
function normalizePresignedFilesResponse(res) {
  const files = get(res, ['data', 'data', 'files'], get(res, ['data', 'files'], []));
  return Array.isArray(files) ? files : [files];
}

/** Function to Add new Document Type (single or multiple files, max MAX_DOCUMENT_FILES) */
function* addDocumentType(payload) {
  try {
    const certificate = Array.isArray(payload.certificate)
      ? payload.certificate
      : payload.certificate
        ? [payload.certificate]
        : [];

    if (certificate.length === 0) {
      notification.warning({ message: 'Please select at least one file.' });
      yield put(addDocumentTypeFailure());
      return;
    }

    if (certificate.length > MAX_DOCUMENT_FILES) {
      notification.error({
        message: 'Maximum files exceeded',
        description: `You can upload a maximum of ${MAX_DOCUMENT_FILES} files at a time.`,
      });
      yield put(addDocumentTypeFailure());
      return;
    }

    // Single POST: presigned URLs for all files
    const presignedPayload = buildPresignedUrlRequestPayload(payload, certificate);
    const resFile = yield adminAxiosConfig.post(
      '/equipment/documents/presigned-url',
      presignedPayload
    );
    const presignedFiles = normalizePresignedFilesResponse(resFile);

    if (presignedFiles.length !== certificate.length) {
      notification.error({
        message: 'File Uploading Failed.',
        description: 'Presigned URL response did not match number of files.',
      });
      yield put(addDocumentTypeFailure());
      return;
    }

    // Upload each file to S3 (parallel)
    const uploadResults = yield all(
      certificate.map((file, index) => {
        const item = presignedFiles[index] || {};
        const presignedUrl = item.presignedUrl || item.presigned_url;
        if (!presignedUrl) {
          return call(Promise.reject, new Error(`Missing presigned URL for file ${index + 1}`));
        }
        return call(axios.put, presignedUrl, file, {
          headers: { 'Content-Type': file.type },
        });
      })
    );

    const uploadFailed = uploadResults.some((r) => !r || r.status !== 200);
    if (uploadFailed) {
      notification.error({ message: 'File Uploading Failed. Please try again.' });
      yield put(addDocumentTypeFailure());
      return;
    }

    // Validate all fileKeys present before batch POST
    const missingKey = presignedFiles.some(
      (item) => !(item.fileKey || item.file_key)
    );
    if (missingKey) {
      notification.error({ message: 'File Uploading Failed. Missing file key in response.' });
      yield put(addDocumentTypeFailure());
      return;
    }

    // Single POST /equipment/documents with documents array
    const batchPayload = buildDocumentBatchPayload(payload, certificate, presignedFiles);
    const res = yield adminAxiosConfig.post(`/equipment/documents`, batchPayload);

    if (res.status !== 200) {
      notification.error({ message: 'Something went wrong.' });
      yield put(addDocumentTypeFailure());
      return;
    }

    notification.destroy();
    notification.success({
      message:
        certificate.length === 1
          ? 'Document Added Successfully.'
          : `${certificate.length} documents added successfully.`,
    });
    yield put(addDocumentTypeSuccess());
    yield put(fetchAdminPihEquipTypes());
    if (payload.equipmentDocTypeId) {
      yield fetchAdminEquipDocList({
        equipmentTypeId: payload.equipmentDocTypeId,
        equipmentId: '',
        documentTypeId: payload.documentDocTypeId,
      });
    }
  } catch (error) {
    yield put(addDocumentTypeFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while adding the Document',
      description: get(error, 'error', get(error, 'message', String(error))),
    });
  }
}

/** Function to Add new Equipments (Serial Number) */
function* addAdminEquipSno({ payload }) {
  try {
    // const res = yield adminAxiosConfig.post(`/equipment`, payload);
    const res = yield adminAxiosConfig.post(`/equipments-for-pih-equipment-type`, payload);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield put(addAdminEquipSnoSuccess({ response }));
      // yield fetchAdminEquipSno({ id: payload.equipment.equipmentTypeId });
      yield fetchAdminEquipTypeSno({ pihEquipmentType: payload.equipment.pihEquipmentType });
      notification.success({
        message: 'Equipment Added Successfully.',
      });
    } else {
      yield put(addAdminEquipSnoFailure());
      notification.error({
        message: 'Something went wrong.Please try again!',
      });
    }
  } catch (error) {
    yield put(addAdminEquipSnoFailure());
    notification.destroy();
    if (error.error === 'Validation error') {
      notification.warn({
        message: 'Selected Equipment already exist!',
      });
    } else {
      notification.error({
        message: 'A problem occured while adding the details.',
        description: `${error}`,
      });
    }
  }
}

/** Function to update Equipment */
function* updateSerialNo({ data, id }) {
  try {
    const res = yield adminAxiosConfig.put(`/equipment/${id}`, data);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield put(updateSerialNoSuccess({ response }));
      // yield fetchAdminEquipSno({ id: data.equipment.equipmentTypeId });
      yield fetchAdminEquipTypeSno({ pihEquipmentType: data.equipment.pihEquipmentType });
      notification.success({
        message: 'Equipment Updated Successfully.',
      });
    } else {
      yield put(updateSerialNoFailure());
      notification.error({
        message: 'Something went wrong. Please try again later',
      });
    }
  } catch (error) {
    yield put(updateSerialNoFailure());
    notification.destroy();
    notification.error({
      message: 'Equipment Type Updation Failed.',
      description: `${error}`,
    });
  }
}

/** Function to delete Equipment Types */
function* deleteSerialNo({ id, equipmentId, pihEquipmentType }) {
  try {
    const res = yield adminAxiosConfig.delete(`/equipment/${id}`);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield put(deleteSerialNoSuccess({ response }));
      // yield fetchAdminEquipSno({ id: equipmentId });
      yield fetchAdminEquipTypeSno({ pihEquipmentType: pihEquipmentType });
      notification.success({
        message: 'Equipment Deleted Successfully.',
      });
    } else {
      yield put(deleteSerialNoFailure());
      notification.error({
        message: 'Something went wrong. Please try again later',
      });
    }
  } catch (error) {
    yield put(deleteSerialNoFailure());
    notification.destroy();
    notification.error({
      message: 'Equipment Deletion Failed.',
      description: `${error}`,
    });
  }
}

// delete document list report
function* deleteDocumentListReport({ equipmentTypeId, equipmentId, documentTypeId, s3Link, serialNumber }) {
  try {
    // Build query parameters
    const params = new URLSearchParams();
    params.append('s3Link', s3Link);
    params.append('equipmentTypeId', equipmentTypeId);
    params.append('documentTypeId', documentTypeId);
    if (serialNumber) {
      params.append('serialNumber', serialNumber);
    }
    
    const res = yield adminAxiosConfig.delete(`/equipment/documents?${params.toString()}`);
    const response = get(res, ['data', 'data'], {});
    notification.destroy();
    if (res.status === 200) {
      yield fetchAdminEquipDocList({ equipmentTypeId, equipmentId, documentTypeId });
      yield put(deleteDocumentListReportSuccess());
      notification.success({
        message: 'Document Deleted Successfully.',
      });
    } else {
      yield put(deleteDocumentListReportFailure());
      notification.error({
        message: 'Something went wrong. Please try again later',
      });
    }
  } catch (error) {
    yield put(deleteDocumentListReportFailure());
    notification.destroy();
    notification.error({
      message: 'Document Deletion Failed.',
      description: `${error.error}`,
    });
  }
}

/** Function to Update Document */
function* updateDocument(payload) {
  try {
    let fileUrl = payload.documentS3Link || payload.existingDocumentName; // Use documentS3Link if provided, otherwise use document name

    // If a new file is provided, upload it first
    if (payload?.certificate && payload.certificate.length > 0) {
      const fileName = encodeURIComponent(payload.certificate[0].name);
      const contentType = encodeURIComponent(payload.certificate[0].type);
      
      const resFile = yield adminAxiosConfig.get(
        `/equipment/documents/presigned-url?fileName=${fileName}&contentType=${contentType}&equipmentTypeId=${payload.equipmentTypeId}&documentTypeId=${payload.documentTypeId}`
      );
      const responseFile = get(resFile, ['data', 'data'], {});

      if (responseFile && responseFile.presignedUrl) {
        // Upload file to S3 using presigned URL
        const presignedResponse = yield axios.put(
          responseFile.presignedUrl,
          payload.certificate[0],
          {
            headers: {
              'Content-Type': payload.certificate[0].type,
            },
          }
        );
        
        if (presignedResponse.status === 200) {
          // Use the fileKey or s3Link from the response
          fileUrl = responseFile.s3Link || responseFile.fileKey || responseFile.url;
        } else {
          notification.error({ message: 'File Uploading Failed. Please try again.' });
          yield put(updateDocumentFailure());
          return;
        }
      } else {
        notification.error({ message: 'Failed to get presigned URL. Please try again.' });
        yield put(updateDocumentFailure());
        return;
      }
    }

    // Call PUT endpoint to update document
    const updatePayload = {
      equipmentTypeId: payload.equipmentTypeId,
      equipmentId: payload.equipmentId || '',
      documentTypeId: payload.documentTypeId,
      existingDocumentName: payload.existingDocumentName,
      newDocumentName: payload.newDocumentName,
      fileUrl: fileUrl,
    };
    
    // Add expiration date and reminder values if provided (for Asset Certs & Tests)
    if (payload.expirationDate) {
      updatePayload.expirationDate = payload.expirationDate;
    }
    if (payload.reminderList) {
      updatePayload.reminderList = payload.reminderList;
    }

    console.log("[Saga] Full payload received:", payload);
    console.log("[Saga] payload.serialNumber:", payload.serialNumber);
    
    // Add serialNumber if provided (from assignedTo of the selected row)
    if (payload.serialNumber) {
      updatePayload.serialNumber = payload.serialNumber;
      console.log("[Saga] Added serialNumber to updatePayload:", updatePayload.serialNumber);
    } else {
      console.log("[Saga] WARNING: serialNumber NOT found in payload!");
    }
    
    // Add documentId and documentS3Link if provided
    if (payload.documentId) {
      updatePayload.documentId = payload.documentId;
    }
    if (payload.documentS3Link) {
      updatePayload.documentS3Link = payload.documentS3Link;
    }
    
    console.log("[Saga] Final updatePayload being sent to API:", updatePayload);
    
    const res = yield adminAxiosConfig.put(`/equipment/documents`, updatePayload);

    if (res.status === 200) {
      notification.success({
        message: 'Document Updated Successfully.',
      });
      
      // Refresh the document list
      yield fetchAdminEquipDocList({
        equipmentTypeId: payload.equipmentTypeId,
        equipmentId: '',
        documentTypeId: payload.documentTypeId,
      });
      
      yield put(updateDocumentSuccess());
    } else {
      yield put(updateDocumentFailure());
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(updateDocumentFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while updating the Document',
      description: `${error?.response?.data?.message || error?.message || error?.error || 'Unknown error'}`,
    });
  }
}

function* sowWatcher() {
  yield takeLatest(FETCH_ADMIN_EQUIPMENT_SNO, fetchAdminEquipSno);
  yield takeLatest(FETCH_ADMIN_EQUIPMENT_CATEGORY, fetchAdminEquipCategory);
  yield takeLatest(FETCH_ADMIN_EQUIPMENT_TYPE_SNO, fetchAdminEquipTypeSno);
  yield takeLatest(FETCH_ADMIN_EQUIPMENT_SUB_TYPE_SNO, fetchAdminEquipSubTypeSno);
  yield takeLatest(FETCH_ADMIN_DOCUMENT_SUB_TYPE_SNO, fetchAdminDocumentSubTypeSno);
  yield takeLatest(FETCH_ADMIN_EQUIPMENT_DOC_TYPE, fetchAdminEquipDocType);
  yield takeLatest(FETCH_ADMIN_EQUIPMENT_DOC_LIST, fetchAdminEquipDocList);
  yield takeLatest(ADD_DOCUMENT_TYPE, addDocumentType);
  yield takeLatest(ADD_EQUIPMENT_SNO, addAdminEquipSno);
  yield takeLatest(UPDATE_EQUIPMENT_SNO, updateSerialNo);
  yield takeLatest(DELETE_EQUIPMENT_SNO, deleteSerialNo);
  yield takeLatest(DELETE_DOCUMENT_LIST_REPORT, deleteDocumentListReport);
  yield takeLatest(UPDATE_DOCUMENT, updateDocument);
}

function* adminEquipSnoSagas() {
  yield all([call(sowWatcher)]);
}

export default adminEquipSnoSagas;
